import dynamic from "next/dynamic";
const ButtonTagsGridComponent = dynamic(()=>import("./button-tags-grid-component"));
import ButtonTagsGridConfig from "./button-tags-grid-config";
import ButtonTagsGridAdvancedConfig from "./button-tags-grid-advanced-config";
export default {
    ButtonTagsGridComponent,
    ButtonTagsGridConfig,
    ButtonTagsGridAdvancedConfig
};
